'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var componentsSpan = require('@keytrade/components-span');
var functions = require('@keytrade/functions');
var formatNumber = functions.format.number;
var mapSizeToSpan = function mapSizeToSpan(size) {
  switch (size) {
    case 'sm':
      return 'bodySm';
    case 'md':
      return 'bodyMd';
    case 'lg':
      return 'bodyLg';
    case 'inherit':
    default:
      return null;
  }
};
var Container = styled.span.withConfig({
  displayName: "Money__Container",
  componentId: "sc-1ccl175-0"
})(["margin:", ";display:", ";flex-direction:row;flex-wrap:nowrap;flex-grow:0;flex-shrink:0;align-items:flex-start;line-height:inherit;span{white-space:pre;}sup{margin-left:2px;font-size:.55em;line-height:1.9;vertical-align:top;}"], function (props) {
  return props.margin;
}, function (props) {
  return props.inline ? 'inline-flex' : 'flex';
});
var Money = function Money(_ref) {
  var amount = _ref.amount,
    digits = _ref.digits,
    color = _ref.color,
    currency = _ref.currency,
    withPositiveHighlight = _ref.withPositiveHighlight,
    withHighlight = _ref.withHighlight,
    withPlus = _ref.withPlus,
    size = _ref.size,
    inline = _ref.inline,
    margin = _ref.margin;
  var adaptedColor = color;
  var adaptedAmount = formatNumber(Math.abs(amount), digits);
  if (amount > 0) {
    if (withPlus) adaptedAmount = "+ ".concat(adaptedAmount);
    if (withHighlight || withPositiveHighlight) adaptedColor = 'GreenSeafoam';
  } else if (amount < 0) {
    if (withHighlight) adaptedColor = 'Tomato';
    adaptedAmount = "- ".concat(adaptedAmount);
  }
  return /*#__PURE__*/React.createElement(Container, {
    inline: inline,
    margin: margin
  }, /*#__PURE__*/React.createElement(componentsSpan.Span, {
    color: adaptedColor !== 'inherit' ? adaptedColor : undefined,
    size: mapSizeToSpan(size)
  }, "".concat(adaptedAmount), currency && /*#__PURE__*/React.createElement("sup", null, currency)));
};
Money.defaultProps = {
  digits: 2,
  size: 'md',
  color: 'BlueDark'
};
exports.Money = Money;